import React from 'react';
import { Form, Input, Select } from 'antd';
import { checkNumber, conditionCheckNumber } from 'util/validators';

const { Option } = Select;

const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
  state = {
    editing: this.props.isEditable || false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.isReset !== prevProps.isReset) {
      this.form.resetFields();
    }
  }

  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({ editing }, () => {
      if (editing) {
        this.input.focus();
      }
    });
  };

  save = (key, inputValue = '') => {
    const { record, handleSave, handleError, isEditable } = this.props;
    const value = inputValue || this.form.getFieldValue(key);

    if (key === 'name' || key === 'level') {
      if (!value) {
        handleError(true);
        return;
      }
    }

    if (key === 'value') {
      if (!conditionCheckNumber(value)) {
        handleError(true);
        return;
      }
    }

    if (!isEditable) {
      this.toggleEdit();
    }

    handleError(false);
    handleSave({ ...record, [key]: value });
  };

  renderCell = form => {
    this.form = form;
    const { children, dataIndex, record, title } = this.props;
    const { editing } = this.state;
    const indexField = `${dataIndex}_${record.key}`;
    return editing ? dataIndex === 'level' ?
    (
      <Form.Item style={{ margin: 0 }}>
        {form.getFieldDecorator(indexField, {
          initialValue: record[dataIndex] || 'level1',
        })(<Select placeholder='Chọn Level' ref={node => (this.input = node)} style={{ width: 300 }} onChange={e => this.save(dataIndex, e)}>
            <Option key='level1' value='level1'>Level 1</Option>
            <Option key='level2' value='level2'>Level 2</Option>
            <Option key='level3' value='level3'>Level 3</Option>
        </Select>)}
      </Form.Item>
    )
    : dataIndex === 'name' ?
    (
      <Form.Item style={{ margin: 0 }}>
        {form.getFieldDecorator(indexField, {
          rules: [{ required: true, message: 'Nhập dữ liệu bắt buộc' }],
          initialValue: record[dataIndex],
        })(<Input placeholder={title} ref={node => (this.input = node)} style={{ width: 300 }} onChange={e => this.save(dataIndex, e.target.value)} />)}
      </Form.Item>
    )
    : (
      <Form.Item style={{ margin: 0 }}>
        {form.getFieldDecorator(indexField, {
          rules: [{ validator: checkNumber }],
          initialValue: record[dataIndex],
        })(<Input placeholder={title} ref={node => (this.input = node)} style={{ width: 300 }} onChange={e => this.save(dataIndex, e.target.value)} />)}
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{ paddingRight: 24 }}
        onClick={this.toggleEdit}
      >
        {children}
      </div>
    );
  };

  render() {
    const {
      editable,
      dataIndex,
      title,
      record,
      index,
      handleSave,
      handleError,
      children,
      isEditable,
      isReset,
      ...restProps
    } = this.props;
    return (
      <td {...restProps}>
        {editable ? (
          <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
        ) : (
          children
        )}
      </td>
    );
  }
}

export {
  EditableFormRow,
  EditableCell,
}
